export default {
  allowAlignment: false,
  anchorEditor: false,
  anchorPreview: false,
  textFormatter: false,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowCode: true,
  autoFocusTopLeft: false,
  urlReplacement: false,
  markdownLinks: false,
  readOnly: true
};